import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

import { PATIENTS_LIST_STATUS } from "@/utils";

const patientStatusPillVariants = tv({
  slots: {
    container: "flex items-center rounded-full px-20 py-3",
    text: "text-xs font-medium capitalize",
  },

  variants: {
    status: {
      patient: {
        container: "bg-success-50",
        text: "text-success-950",
      },
      transfer: {
        container: "bg-warning-50",
        text: "text-warning-950",
      },
      disqualified: {
        container: "bg-error-100",
        text: "text-yellow-700",
      },
    },
  },

  defaultVariants: {
    status: PATIENTS_LIST_STATUS.INTAKE,
  },
});

type PatientStatusPillProps = VariantProps<typeof patientStatusPillVariants>;

export function PatientStatusPill({ status }: PatientStatusPillProps) {
  const { container, text } = patientStatusPillVariants({ status });
  return (
    <div className={container()}>
      <p className={text()}>{status}</p>
    </div>
  );
}
